import { render, staticRenderFns } from "./MessageActions.vue?vue&type=template&id=27f1a961&"
import script from "./MessageActions.vue?vue&type=script&lang=js&"
export * from "./MessageActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports